import type { ReactNode } from 'react'
import type { IGetCompanyBillingTeamList } from '../../types/teams'
import type { IGetLocationsWithLeavePoliciesShort } from '../../types/locations'
import type { IGetLeaveTypeListLimits } from '../../types/company'
import type { SubscriptionPeriod } from '@vacationtracker/shared/types/billing'

export type DowngradeType = 'complete-to-core' | 'to-freemium'

export interface IEntitySelections {
  selectedDepartmentIds: string[] // Multi-select for Core, single for Freemium
  selectedLocationIds: string[] // Multi-select for Core, single for Freemium
  selectedLeaveTypeIds: string[] // Multi-select for Core, single for Freemium
}

export interface IEntitySourceData {
  teams: IGetCompanyBillingTeamList[]
  locations: IGetLocationsWithLeavePoliciesShort[]
  leaveTypes: IGetLeaveTypeListLimits[]
}

export interface IPlanDowngradeModalProps {
  visible: boolean
  onCancel: () => void
  onSubmit: (selections: IEntitySelections) => Promise<void>
  sourceData: IEntitySourceData
  downgradeType: DowngradeType
  targetPlan: 'Core' | 'Freemium'
  currentPeriod?: SubscriptionPeriod
  endDatePeriod?: string
  numberOfActiveUsers?: number
  isTrialPeriod?: boolean
  source?: string
  analyticsOverrides?: {
    activeUsers?: number
    stripePaymentStatus?: string
  }
  // When false, the modal can only be left by submitting or through extraFooterAction
  closable?: boolean
  boostCopy?: IPlanDowngradeBoostCopy
  // Fewer picks than the plan keeps would delete entities the company could have kept
  requireFullSelection?: boolean
  // Some deletion events may have been sent already, so the caller should reload sourceData before a retry
  onSubmitFailed?: () => void
  extraFooterAction?: ReactNode
}

export interface IPlanDowngradeBoostCopy {
  title: ReactNode
  description: ReactNode
  submitLabel: ReactNode
}

export interface IEntityLimits {
  departments: number
  locations: number
  leaveTypes: number
}

export const PLAN_LIMITS: Record<'Core' | 'Freemium', IEntityLimits> = {
  Core: {
    departments: 10,
    locations: 3,
    leaveTypes: 999, // Unlimited
  },
  Freemium: {
    departments: 1,
    locations: 1,
    leaveTypes: 1,
  },
}
